import { create } from "zustand";

interface ToastState {
  message: string | null;
  type: "success" | "error" | "info" | null;
  showToast: (message: string, type?: "success" | "error" | "info", duration?: number) => void;
  hideToast: () => void;
}

export const useToastStore = create<ToastState>((set) => ({
  message: null,
  type: null,
  showToast: (message, type = "info", duration = 3000) => {
    set({ message, type });

    // Automatically hide the toast after 'duration' milliseconds
    setTimeout(() => {
      set({ message: null, type: null });
    }, duration);
  },
  hideToast: () => set({ message: null, type: null }),
}));
